import { BridgeComponent } from "@hotwired/hotwire-native-bridge";

export default class PremierePlayerController extends BridgeComponent {
  static component = "premiere-player";

  connect() {
    // Installs the library's native:restore listener, which re-runs connect() (re-sending
    // this payload) when the native shell restores the screen without a Turbo visit.
    super.connect();

    this.send("connect", {
      itemId: this.element.getAttribute("data-item-id"),
      itemType: this.element.getAttribute("data-item-type"),
      title: this.element.getAttribute("data-title"),
      streamType: "premiere",
      hlsUrl: this.element.getAttribute("data-playlist-url"),
      originalUrl: this.element.getAttribute("data-original-url"),
      publishedAtMs: Number(this.element.getAttribute("data-published-at-ms")),
      serverNowMs: Number(this.element.getAttribute("data-server-now-ms")),
      durationSeconds: Number(this.element.getAttribute("data-duration-seconds")),
      isAwsHls: this.element.getAttribute("data-media--video-player-aws-hls-value") === "true",
      hlsToken: this.element.getAttribute("data-media--video-player-hls-token-value"),
    }, () => {
      // Native playback is up - hide the fallback thumbnail that old apps
      // (without this component) rely on.
      this.fallbackThumbnail()?.classList.add("!hidden");
    });
  }

  disconnect() {
    this.send("disconnect");
    // Cleans up the connect-reply callback the library keeps registered per message id;
    // without this each visit leaks its callback (and detached DOM) for the webview's life.
    super.disconnect();
  }

  fallbackThumbnail() {
    return this.element.closest("[data-video-player-container]")?.querySelector("[data-native-premiere-fallback]");
  }
}
